import React from "react";

import { AddFilterBaseFunc, IFilterKeys, IFilters, IPlotData, RemoveFilterBaseFunc } from "models/core";
import { DashboardFilterKeys } from "models/youthCancer";
import { ChartOrientation, ChartType, QoolDashChart } from "../core";

interface IProps {
	plotData: IPlotData;
	activeFilters: IFilters<IFilterKeys>;
	addFilterFn: AddFilterBaseFunc<typeof DashboardFilterKeys>;
    removeFilterFn: RemoveFilterBaseFunc<typeof DashboardFilterKeys>;
}

export function FertilityPreservationChart(props: IProps) {

	return (
		<QoolDashChart
			xAxis={{ horizontalOrientation: { label: "Number of Diagnoses" }, verticalOrientation: { label: "" }}}
			yAxis={{ horizontalOrientation: { label: "" }, verticalOrientation: { label: "Number of Diagnoses" }}}
			chartOrder={{ horizontalOrientation: { reversed: false }, verticalOrientation: { reversed: true }}}
			defaultChartOrientation={ChartOrientation.Horizontal}
			defaultChartType={ChartType.Bar}
			chartTitle="Fertility preservation"
			filterKey={DashboardFilterKeys.FertilityPreservation.key}
			plotData={[props.plotData]}
			activeFilters={props.activeFilters}
			addFilterFn={props.addFilterFn}
			removeFilterFn={props.removeFilterFn}
			hoverText="Diagnoses"
			chartDimensions={{
				chartHeightProportion: 50,
				parentColNumber: 12,
				tabColNumber: 4
			}}
			sortUnknownToEnd={true}
		/>
	)
}
